import PropTypes from 'prop-types'
import {
  Grid,
  Radio,
  RadioGroup,
  Box,
  FormControlLabel,
  TextField,
  Switch,
  Divider,
  Typography,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import { routes } from 'Routes'
import { useHistory } from 'react-router-dom'

import constants from 'constants/index'

import { Controller } from 'react-hook-form'

import { Card, Label, ButtonComponent } from 'components'
import Contractor from '../../../Contractor'

const Facture = ({
  control,
  errors,
  isNew,
  watch,
  displaySelected = false,
  isShow,
}) => {
  const history = useHistory()

  const handleCreateUser = () => {
    const typeCompany =
      watch('typeFacture') === 'newCompany'
        ? constants.preRegistration.CLIENT_TYPE
        : constants.preRegistration.SUBLICENSE_TYPE

    history.push(routes.preRegistrations.new, {
      type: constants.preRegistration.TYPE_REAL,
      typeClient: typeCompany,
      createContract: true,
    })
  }

  const preRegistration = watch('preRegistration')

  return (
    <Card title="Faturar para">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Label title="Crie ou selecione um cliente/sublicenciamento para ser responsável pelo faturamento do contrato">
            <Controller
              as={
                <RadioGroup>
                  <Box>
                    <FormControlLabel
                      disabled={!isNew}
                      value="newCompany"
                      control={<Radio color="primary" />}
                      label="Novo cliente"
                    />
                  </Box>
                  <Box>
                    <FormControlLabel
                      disabled={!isNew}
                      value="existing"
                      control={<Radio color="primary" />}
                      label="Cliente/sublicenciamento já existente"
                    />
                  </Box>
                </RadioGroup>
              }
              control={control}
              mode="onChange"
              name="typeFacture"
            />
          </Label>
        </Grid>
        {(watch('typeFacture') === 'existing' || displaySelected) && (
          <Grid item xs={12}>
            <Contractor
              control={control}
              errors={errors}
              isShow={isShow}
              watch={watch}
            />
          </Grid>
        )}
        {['newCompany', 'newSublicense'].includes(watch('typeFacture')) && (
          <Grid item xs={12}>
            <ButtonComponent
              type="button"
              onClick={handleCreateUser}
              title={`Criar ${
                watch('typeFacture') === 'newCompany'
                  ? 'cliente'
                  : 'sublicenciamento'
              }`}
            />
          </Grid>
        )}
        {preRegistration && (
          <>
            {!isShow && (
              <Grid item xs={12}>
                <Box my={2}>
                  <Divider />
                </Box>
                <Alert severity="info">
                  <Typography variant="body2">
                    {preRegistration?.quantityContracts > 0
                      ? 'Como essa empresa (responsável pelo faturamento) já possui contrato(s), ela não deve ser considerada no limite de empresas.'
                      : 'Como essa empresa (responsável pelo faturamento) não possui contrato(s), ela deve ser considerada no limite de empresas.'}
                  </Typography>
                </Alert>
              </Grid>
            )}
            <Grid item xs={12} md={6}>
              <Controller
                as={
                  <TextField
                    fullWidth
                    label="Limite de empresas"
                    variant="outlined"
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    error={!!errors?.countCompanyInLimit}
                    helperText={errors?.countCompanyInLimit?.message}
                    disabled={isShow}
                  />
                }
                control={control}
                mode="onChange"
                name="countCompanyInLimit"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Label title="Contabilizar responsável pelo faturamento no limite de empresas">
                <FormControlLabel
                  control={
                    <Controller
                      as={<Switch color="primary" />}
                      name="responsibleInLimit"
                      control={control}
                      onChange={([event]) => event.target.checked}
                      disabled={isShow}
                    />
                  }
                  label="Sim"
                />
              </Label>
            </Grid>
          </>
        )}
      </Grid>
    </Card>
  )
}

Facture.propTypes = {
  control: PropTypes.object,
  preRegistrations: PropTypes.array,
  errors: PropTypes.object,
  isNew: PropTypes.bool,
  watch: PropTypes.func,
  displaySelected: PropTypes.bool,
  isShow: PropTypes.bool,
}

export default Facture
